import React from 'react'
import Documents from '../components/Amission/Documents'
import data from '../resources/documents.json'
const DocumentsRequired = () => {
  return (
    <Documents data={data}/>
  )
}

export default DocumentsRequired